"use client";

import { use } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionTrigger,
} from "@tillix/ui-atoms/atoms/accordion";
import { useT } from "@/features/i18n/hooks/use-t";
import type { TermsSection } from "./hc-terms-data";

interface HcTermsContentProps {
  termsPromise: Promise<TermsSection[]>;
}

export default function HcTermsContent({ termsPromise }: HcTermsContentProps) {
  const sections = use(termsPromise);
  const { t } = useT();

  if (sections.length === 0) {
    return (
      <p className="text-muted-foreground">{t("terms.noTermsAvailable")}</p>
    );
  }

  return (
    <Accordion defaultValue={[sections[0].id]} multiple={true}>
      {sections.map((section) => (
        <AccordionItem key={section.id} value={section.id}>
          <AccordionTrigger className="text-left hover:no-underline">
            {t(section.titleKey)}
          </AccordionTrigger>
          <AccordionPanel>
            <div className="space-y-3">
              {section.paragraphKeys.map((key) => (
                <p className="text-muted-foreground leading-relaxed" key={key}>
                  {t(key)}
                </p>
              ))}
            </div>
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
